/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A claim status template defining available statuses and associated tasks
 * @export
 * @interface ClaimStatusTemplate
 */
export interface ClaimStatusTemplate {
    /**
     * Unique status template ID
     * @type {number}
     * @memberof ClaimStatusTemplate
     */
    readonly id: number;
    /**
     * Name of the status (e.g., "Open", "In Progress", "Closed")
     * @type {string}
     * @memberof ClaimStatusTemplate
     */
    displayName: string;
    /**
     * Order in which statuses should be displayed
     * @type {number}
     * @memberof ClaimStatusTemplate
     */
    displayOrder: number;
    /**
     * Whether this is a system default status that cannot be deleted
     * @type {boolean}
     * @memberof ClaimStatusTemplate
     */
    isSystemDefault: boolean;
    /**
     * Optional color code for UI display (e.g., "#4CAF50")
     * @type {string}
     * @memberof ClaimStatusTemplate
     */
    color?: string | null;
    /**
     * Optional description of the status
     * @type {string}
     * @memberof ClaimStatusTemplate
     */
    description?: string | null;
    /**
     * ID of the company this status belongs to
     * @type {number}
     * @memberof ClaimStatusTemplate
     */
    companyId: number;
    /**
     * ID of the pipeline this status belongs to. displayOrder orders statuses within the pipeline.
     * @type {number}
     * @memberof ClaimStatusTemplate
     */
    pipelineId: number;
    /**
     * Whether this status is active
     * @type {boolean}
     * @memberof ClaimStatusTemplate
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ClaimStatusTemplate
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimStatusTemplate
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the ClaimStatusTemplate interface.
 */
export function instanceOfClaimStatusTemplate(value: object): value is ClaimStatusTemplate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    if (!('isSystemDefault' in value) || value['isSystemDefault'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('pipelineId' in value) || value['pipelineId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ClaimStatusTemplateFromJSON(json: any): ClaimStatusTemplate {
    return ClaimStatusTemplateFromJSONTyped(json, false);
}

export function ClaimStatusTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimStatusTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        'displayOrder': json['displayOrder'],
        'isSystemDefault': json['isSystemDefault'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
        'companyId': json['companyId'],
        'pipelineId': json['pipelineId'],
        'isActive': json['isActive'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ClaimStatusTemplateToJSON(json: any): ClaimStatusTemplate {
    return ClaimStatusTemplateToJSONTyped(json, false);
}

export function ClaimStatusTemplateToJSONTyped(value?: Omit<ClaimStatusTemplate, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'displayOrder': value['displayOrder'],
        'isSystemDefault': value['isSystemDefault'],
        'color': value['color'],
        'description': value['description'],
        'companyId': value['companyId'],
        'pipelineId': value['pipelineId'],
        'isActive': value['isActive'],
    };
}

